import dayjs from 'dayjs';
import { formatPhone } from 'utils/formatters';
import { escapeHtml } from 'utils/html';

import type { CheckoutFormValues } from './CheckoutContext';

const MERGE_FIELD_PLACEHOLDER = '____________';

/**
 * Fills the athlete merge fields of a contract or waiver preview with the details the
 * buyer entered for the athlete the purchase is for. The preview leaves them in place
 * because that athlete may not exist yet; values are formatted like the signed document.
 */
export function fillAthleteMergeFields(
  html: string,
  athlete: CheckoutFormValues['athleteInformation'],
): string {
  const { address } = athlete;
  const values = {
    ATHLETE_NAME: `${athlete.firstName} ${athlete.lastName}`.trim(),
    ATHLETE_EMAIL_ADDRESS: athlete.email,
    ATHLETE_ADDRESS: address
      ? [address.addressLines, address.locality, address.region, address.zipCode, address.country]
          .filter(Boolean)
          .join(' ')
      : '',
    ATHLETE_PHONE_NUMBER: formatPhone(athlete.phone),
    ATHLETE_DATE_OF_BIRTH: athlete.dob ? dayjs(athlete.dob).format('MMMM DD, YYYY') : '',
    ATHLETE_GENDER: athlete.gender ?? '',
  };
  return Object.entries(values).reduce(
    (filled, [field, value]) =>
      filled.replaceAll(field, value ? escapeHtml(value) : MERGE_FIELD_PLACEHOLDER),
    html,
  );
}
